export const issueTypes = {
    ChargingError: "Charging Error",
    TopupError: "Topup Error",
    Other: "Other",
}

export const issueStatuses = {
    Pending: "Pending",
    InProgress: "In Progress", 
    Resolved: "Resolved",
    Cancelled: "Cancelled"
}
